import React from "react";
import "./FloatingBottom.css";
import PosCustomIcon from "../../../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { ReceiptPercentIcon, UserIcon } from "@heroicons/react/24/outline";
import { PosCustomButton } from "../../../../../../../../customComponents/PosCustomButton/PosCustomButton";
import { CircularProgress } from "@mui/material";
import { getStoreCurrencySymbol } from "../../../../../../../../utils/currency";

const FloatingBottom = ({
  customerMobile,
  customerName,
  coupon,
  loyalty,
  amountArray = [],
  isSalesOrder,
  saleMode,
  offerFound,
  cartItems,
  total,
  normalizeNumber,
  partialStatus,
  adjustCheck,
  splitActive,
  amtToBePaid,
  amountPaid,
  amtHeading,
  handleOfferCalculate,
  handleOpenPaymentModal,
  handleDeliveryPopUp,
  createOrderFun,
  offerLoader,
  isPlacingDelivery,
  loaderAdj,
  cartId,
  onAddCustomer,
  cartTotalQty,
}) => {
  const payableAmount = !partialStatus
    ? adjustCheck || splitActive
      ? normalizeNumber(amtToBePaid)
      : normalizeNumber(total)
    : normalizeNumber(total - amountPaid);

  const payTitle = amtHeading === "Payable Amount (F1)" ? "Pay & Print" : "Pay & Print";

  const totalItemsCount = cartItems?.length || 0;
  const formattedQty = cartTotalQty ?? 0;

  const PrinterIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-printer"
      aria-hidden="true"
    >
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
      <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
      <rect x="6" y="14" width="12" height="8" rx="1"></rect>
    </svg>
  );

  return (
    <div className="groceryBottomBarContainer">
      {!cartId ? (
        /* ── No active cart banner ── */
        <button
          type="button"
          className="fb-no-active-cart"
          onClick={onAddCustomer}
          title="Click to start a new cart"
        >
          <div className="fb-no-active-cart-icon">
            <PosCustomIcon icon={<UserIcon />} height={"18px"} width={"18px"} color="#c2410c" />
          </div>
          <div className="fb-no-active-cart-text">
            <span className="fb-no-active-cart-label">No active Cart</span>
            <span className="fb-no-active-cart-sub">Tap to add customer &amp; start</span>
          </div>
        </button>
      ) : (
        <div className="bottomBarCustomerNameContainer">
          <div className="bottomBarCustomerIcon">
            <PosCustomIcon icon={<UserIcon />} height={"18px"} width={"18px"} color="#2563eb" />
          </div>
          <div className="bottomBarCustomerNameText">
            <p className="bottomBarCustomerNameValue">
              {customerName || customerMobile || "No Customer"}
            </p>
            <p className="walk-in___customer">Walk-in Customer</p>
            <div className="loyalty-points___section">
              <span className="loyalty-points___label">Loyalty Points</span>
              <span className="loyalty-points___value">{loyalty || "0"}</span>
            </div>
          </div>
        </div>
      )}

      <div className="bottomBarMiddleContainer">
        <div className="bottomBarDiscountText">
          <p className="bottomBarDiscountText___name active-grey-text">{"Total Items"}</p>
          <p className="bottomBarDiscountText___mrp" data-testid="text-cart-total-items">
            {totalItemsCount}
          </p>
        </div>

        <div className="bottomBarDiscountText">
          <p className="bottomBarDiscountText___name active-grey-text">{"Total Qty"}</p>
          <p className="bottomBarDiscountText___mrp" data-testid="text-cart-total-qty">
            {formattedQty}
          </p>
        </div>

        {coupon && (
          <div className="bottomBarDiscountText">
            <p className="bottomBarDiscountText___name active-green-text">{"Coupon"}</p>
            <p className="bottomBarDiscountValue">{getStoreCurrencySymbol()}{coupon}</p>
          </div>
        )}

        <div className="bottomBarDiscountText">
          <p className="bottomBarDiscountText___name active-green-text">{"Redeemed Loyalty"}</p>
          <p className="bottomBarDiscountValue">
            {getStoreCurrencySymbol()}{loyalty && loyalty !== "null" && loyalty !== "undefined" ? loyalty : "0"}
          </p>
        </div>

        {loaderAdj ? (
          <CircularProgress size={"16px"} sx={{ color: "var(--surface-white)" }} />
        ) : (
          amountArray
            ?.filter((item) => item?.check)
            ?.map((item, index) => (
              <div key={index} className="bottomBarDiscountText">
                <p className="bottomBarDiscountText___name active-grey-text">{item?.name}</p>
                <p className="bottomBarDiscountText___mrp">{item?.mrp}</p>
              </div>
            ))
        )}
      </div>

      {isSalesOrder && cartId && (
        <div
          className="fb-gst-badge"
          data-testid="badge-gst-invoice"
          title="GST Invoice · B2B Sales Order"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-label="GST Invoice"
          >
            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
            <path d="M14 8H8" />
            <path d="M16 12H8" />
            <path d="M13 16H8" />
          </svg>
          <span className="fb-gst-badge-label">GST</span>
        </div>
      )}

      <div className="bottomBarActionButtonContainer">
        {saleMode === "delivery" && (
          <PosCustomButton
            variant="blue-d"
            title="Add Delivery Charge"
            disabled={!cartItems?.length}
            onClickFunction={handleDeliveryPopUp}
            loading={isPlacingDelivery}
            p="14px"
            radius="50px"
          />
        )}

        {/* {offerFound ? ( */}
        {offerFound && cartItems?.some((p) => p?.isOfferAvailable && !p?.offerApplied) ? (
          <PosCustomButton
            disabled={!cartItems?.length}
            variant="blue-d"
            onClickFunction={handleOfferCalculate}
            loading={offerLoader}
            title="Apply Offer"
            radius="50px"
            p="14px"
            iconOnRight={
              <PosCustomIcon
                icon={<ReceiptPercentIcon />}
                height={"16px"}
                width={"16px"}
                color="var(--surface-white)"
              />
            }
          />
        ) : saleMode === "delivery" ? (
          <PosCustomButton
            disabled={!cartItems?.length}
            variant="blue-d"
            onClickFunction={createOrderFun}
            title={`Pay & Print (F1) | ${getStoreCurrencySymbol()}${normalizeNumber(total)}`}
            p="14px"
            radius="50px"
            iconOnLeft={PrinterIcon}
          />
        ) : (
          <PosCustomButton
            disabled={!cartItems?.length}
            variant="blue-d"
            onClickFunction={handleOpenPaymentModal}
            title={`${payTitle} (F1) | ${getStoreCurrencySymbol()}${payableAmount}`}
            p="14px"
            radius="50px"
            iconOnLeft={PrinterIcon}
          />
        )}
      </div>
    </div>
  );
};

export default FloatingBottom;
